import React from "react";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import TextField from "@mui/material/TextField";
import { useAtomValue } from "jotai";
import { companyCurrencySymbolAtom } from "../atoms/atoms";

function NumberFormatCustom(props) {
    const { inputRef, onChange, prefix, ...other } = props;
    const companyCurrencySymbol = useAtomValue(companyCurrencySymbolAtom);

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value
                    }
                });
            }}
            thousandSeparator
            isNumericString
            prefix={prefix ? prefix : companyCurrencySymbol}
        />
    );
}

NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

export function MoneyAmountInput(props) {
    const handleChange = (event) => {
        props.setAmount(event.target.value);
    };

    return (
        <TextField
            sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 }
            }}
            value={props.amount}
            onChange={handleChange}
            prefix={props.prefix}
            name={props.name}
            id={props.name}
            InputProps={{
                inputComponent: NumberFormatCustom,
                shrink: false,
                sx: { textAlign: "end" }
            }}
            inputProps={{
                sx: {
                    textAlign: "right",
                    "&::placeholder": {
                        textAlign: "right"
                    }
                }
            }}
            variant="outlined"
            size="small"
            disabled={props.disabled ? props.disabled : false}
        />
    );
}
